// extracted by mini-css-extract-plugin
export default {"icon":"NoVehiclesFound_icon__EZN9d"};